<template>
  <div>
    <h2>Получить микрозаем может любой гражданин РФ от 18 до 70 лет, который проживает в зоне обслуживания нашей компании. Необходимо наличие стабильного источника дохода, из документов нужен только паспорт.</h2>


  </div>
</template>

<script>
  export default {
    name: "conditions",
    components:{
      // pdfLink:()=>import('@/components/chunk/pdfLink'),
    }
  }
</script>

<style scoped>

</style>
